import types from './types';

export const setShelterName = shelterName => ({
  type: types.SET_UPD_SHELTERT_NAME,
  shelterName
});

export const setKojinInfo = kojinInfo => ({
  type: types.SET_UPD_KOJIN_INFO,
  kojinInfo
});

 export default {
   setShelterName,
   setKojinInfo
 };
